import { Component, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Subject } from 'rxjs';
import { ProfileType } from 'src/app/constants/profile-type';
import { DataTableRequest } from 'src/app/models/datatable-request';
import { DialogData } from 'src/app/models/dialog-data';
import { RiwayatProfile } from 'src/app/models/riwayat-profile.t';
import { ApplicationService } from 'src/app/services/application.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { TokenStorageService } from 'src/app/services/token-storage/token-storage.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { RiwayatProfileData } from './form-riwayat-profile-data.t';
import { FormRiwayatProfileComponent } from './form-riwayat-profile/form-riwayat-profile.component';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-riwayat-profile',
  templateUrl: './riwayat-profile.component.html',
  styleUrls: ['./riwayat-profile.component.css']
})
export class RiwayatProfileComponent implements OnInit, OnDestroy {
  profileId: string = '';
  title: string = '';
  type: number = 0;

  page = 0;
  searchTerm = '';
  length = 0;
  pageSize = 20;
  pageSizeOptions: number[] = [20, 50, 100];
  pageEvent: PageEvent | undefined;

  ProfileType = ProfileType;

  datas: RiwayatProfile[] = [];
  isLoading = false;
  onDestroy$ = new Subject<void>();

  constructor(
    public tokenStorageService: TokenStorageService,
    private applicationService: ApplicationService,
    private profileService: ProfileService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private location: Location,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.route.paramMap.pipe(takeUntil(this.onDestroy$)).subscribe((params) => {
      this.profileId = params.get('profileId')!;
      const typeParam = params.get('type');
      switch (typeParam) {
        case ProfileType.GOLONGAN_TEXT:
          this.type = ProfileType.GOLONGAN;
          this.title = 'Riwayat Golongan';
          break;
        case ProfileType.PENDIDIKAN_TEXT:
          this.type = ProfileType.PENDIDIKAN;
          this.title = 'Riwayat Pendidikan';
          break;
        case ProfileType.JABATAN_TEXT:
          this.type = ProfileType.JABATAN;
          this.title = 'Riwayat Jabatan';
          break;
        case ProfileType.PENINJAUAN_MASA_KERJA_TEXT:
          this.type = ProfileType.PENINJAUAN_MASA_KERJA;
          this.title = 'Peninjauan Masa Kerja';
          break;
        case ProfileType.PNS_TEXT:
          this.type = ProfileType.PNS;
          this.title = 'CPNS / PNS';
          break;
        case ProfileType.DIKLAT_TEXT:
          this.type = ProfileType.DIKLAT;
          this.title = 'Riwayat Diklat';
          break;
        case ProfileType.SKP_TEXT:
          this.type = ProfileType.SKP;
          this.title = 'Riwayat SKP';
          break;
        case ProfileType.PENGHARGAAN_TEXT:
          this.type = ProfileType.PENGHARGAAN;
          this.title = 'Riwayat Penghargaan';
          break;
        case ProfileType.ORGANISASI_TEXT:
          this.type = ProfileType.ORGANISASI;
          this.title = 'Riwayat Organisasi';
          break;
        case ProfileType.CLTN_TEXT:
          this.type = ProfileType.CLTN;
          this.title = 'Riwayat Cuti Luar Tanggunan Negara';
          break;
        case ProfileType.ANGKA_KREDIT_TEXT:
          this.type = ProfileType.ANGKA_KREDIT;
          this.title = 'Angka Kredit';
          break;
        case ProfileType.PROFESI_TEXT:
          this.type = ProfileType.PROFESI;
          this.title = 'Profesi';
          break;
        case ProfileType.PINDAH_INSTANSI_TEXT:
          this.type = ProfileType.PINDAH_INSTANSI;
          this.title = 'Riwayat Pindah Instansi';
          break;
        case ProfileType.KGB_TEXT:
          this.type = ProfileType.KGB;
          this.title = 'Riwayat Kenaikan Gaji Berkala';
          break;
        case ProfileType.BUP_TEXT:
          this.type = ProfileType.BUP;
          this.title = 'Batas Usia Pensiun';
          break;
        case ProfileType.SATYA_LENCANA_TEXT:
          this.type = ProfileType.SATYA_LENCANA;
          this.title = 'Satya Lencana';
          break;
        case ProfileType.KARIS_KARSU_TEXT:
          this.type = ProfileType.KARIS_KARSU;
          this.title = 'Karis/Karsu';
          break;
        case ProfileType.KELUARGA_TEXT:
          this.type = ProfileType.KELUARGA;
          this.title = 'Keluarga';
          break;
      }

      this.reload();
    });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  navigateToProgress(data: RiwayatProfile) {
    this.router.navigate([`/riwayat-progress/${data.id}`]);
  }

  open(data?: RiwayatProfile, title?: string) {
    if (data && data.statusId && data.statusId === 1) {
      this.router.navigate([`/riwayat-progress/${data.id}`]);
    } else {
      this.openDialog(data, title);
    }
  }

  openDialog(data?: RiwayatProfile, title?: string, isPengajuan?: boolean) {
    const riwayatData: RiwayatProfileData = {
      title: title,
      data: data || {},
      isEditable: true,
    };
    const dialogRef = this.dialog.open(FormRiwayatProfileComponent, {
      data: riwayatData,
      disableClose: true,
      maxWidth: '60vw',
      // maxHeight: '95vh',
      // height: '100%',
      width: '100%',
      panelClass: 'width-60-dialog',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.reload();
      }
    });
  }

  search() {
    this.page = 0;
    // this.paginator?.firstPage();
    this.length = 0;
    this.reload();
  }

  confirmDialog(data: RiwayatProfile) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      data: <DialogData>{
        title: 'Peringatan',
        message: 'Apakah Anda yakin akan menghapus data ini?',
        isConfirmation: true,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.isLoading = true;
        this.profileService.delete(data).subscribe(() => {
          this.isLoading = false;
          this.reload();
        });
      }
    });
  }

  getPrefixLabel(data: RiwayatProfile) {
    return data.statusId === 1 ? '[Pengajuan] ' : '';
  }

  back(): void {
    this.location.back();
  }

  private reload(event?: PageEvent) {
    const payload: DataTableRequest = {
      page: event ? event.pageIndex : this.page,
      dataPerPage: event ? event.pageSize : this.pageSize,
      searchTerm: this.searchTerm,
      userId: this.profileId,
      typeId: this.type,
    };
    this.getDatas(payload);
  }

  private getDatas(payload: DataTableRequest) {
    this.isLoading = true;
    this.profileService.getDatas(payload).subscribe((response) => {
      this.datas = response.datas;
      this.length = response.total;
      this.page = response.page;
      this.isLoading = false;
    });
  }

}
